/**
 *@format
 */
import { api } from '@/scripts/api';

export const ClientPaymentsReceivedService = {
    getAll(accountId, config){
        return new Promise((resolve, reject) => {
             const service = `/ms/marketing-development-funds/v1/invoices/payment-received/account/${accountId}`
             const endpint = api.applyNodeDataParams(service, config);

             api.get(endpint).then(resolve).catch(reject)
        })
    },

    getProof(accountId, invoiceId){
        return new Promise((resolve, reject) => {
             const service = `/ms/marketing-development-funds/v1/invoices/partner/${accountId}/invoice/${invoiceId}/view-proof`

             api.get(service).then(resolve).catch(reject)
        })
    },

    postRequestProof(accountId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/payment-proofs/client-account/${accountId}/request`

            api.post(service, payload).then(resolve).catch(reject)
        })
    },
}